import EnvelopeStore from 'src/stores/envelope-store';
import Aggregate from '../aggregates/aggregate';

export default class Envelope extends Aggregate<EnvelopeStore, Envelope> {}
